import React, { forwardRef } from 'react';

import { AGE_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { Radio } from '@vlabs/uikit/components/controls/radio';

import type { Option } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFiltersTranslation } from '../../i18n';
import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

interface AgeOption extends Omit<Option, 'value'> {
  value: [number, number];
}

function AgeFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useEventListFiltersTranslation();
  const { filters, updateFilters } = useEventListFilters();

  const isSelected = ([gte, lt]: [number, number]) => (
    filters.age__gte === gte && filters.age__lt === lt
  );

  const reset = () => updateFilters({ age__gte: undefined, age__lt: undefined });

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={
        filters.age__gte === undefined
        && filters.age__lt === undefined
      }
      onClickReset={reset}
      ref={ref}
      title={<div className="Subtitle-2">{t('apparent_age_popover_title')}</div>}
    >
      <div className={st.RadioWrapper}>
        {AGE_OPTIONS.raw.map((option: AgeOption) => (
          <Radio
            checked={isSelected(option.value)}
            key={option.label}
            label={option.label}
            onChange={() => updateFilters({
              age__gte: option.value[0],
              age__lt: option.value[1],
            })}
          />
        ))}
      </div>
    </PopoverWithButton>
  );
}

const AgeFilterPopoverWithRef = forwardRef(AgeFilterPopover);
export { AgeFilterPopoverWithRef as AgeFilterPopover };
